/**
 * 解决表格组件在设置fixed属性后窗口改变导致组件被销毁的问题
 * 1、inject: ['$cell']无法再被使用
 * 2、组件的销毁时机会往后延迟
 */

import Vue from 'vue'
import DataGridDialog from '../DataGridDialog'
import DataGridDrawer from '../DataGridDrawer'
import DataGridCascade from '../DataGridCascade'
import DataGridPopover from '../DataGridPopover'
import DataImportModule from '../../DataImportModule'
import DataUnpackModule from '../../DataUnpackModule'
import AsyncTaskModule from '../../AsyncTaskModule'

let PopoverDialog = Vue.component('popover-dialog', {
  components: {
    DataGridDialog,
    DataGridPopover
  },
  props: {
    dialogAttrs: Object,
    wrapAttrs: Object,
    attrs: Object,
    listeners: Object
  },
  template:
    `
      <DataGridDialog :visible.sync="visible"
                      v-bind="dialogAttrs">
        <template slot-scope="scope">
          <div v-bind="wrapAttrs">
            <DataGridPopover :visible="visible"
                             :popover-extra="scope"
                             v-bind="attrs"
                             v-on="listeners"></DataGridPopover>
          </div>
        </template>
      </DataGridDialog>
    `
})

let PopoverDrawer = Vue.component('popover-drawer', {
  components: {
    DataGridDrawer,
    DataGridPopover
  },
  props: {
    drawerAttrs: Object,
    attrs: Object,
    listeners: Object
  },
  template:
    `
      <DataGridDrawer :visible.sync="visible"
                      v-bind="drawerAttrs">
        <template slot-scope="scope">
          <DataGridPopover :visible="visible"
                           :popover-extra="scope"
                           v-bind="attrs"
                           v-on="listeners"></DataGridPopover>
        </template>
      </DataGridDrawer>
    `
})

let PopoverCascade = Vue.component('popover-cascade', {
  components: {
    DataGridCascade,
    DataGridPopover
  },
  props: {
    cascadeAttrs: Object,
    attrs: Object,
    listeners: Object
  },
  template:
    `
      <DataGridCascade :visible.sync="visible"
                       v-bind="cascadeAttrs">
        <template slot-scope="scope">
          <DataGridPopover :visible="visible"
                           :popover-extra="scope"
                           v-bind="attrs"
                           v-on="listeners"></DataGridPopover>
        </template>
      </DataGridCascade>
    `
})

let DialogImport = Vue.component('dialog-import', {
  components: {
    DataGridDialog,
    DataImportModule
  },
  props: {
    dialogAttrs: Object,
    attrs: Object,
    listeners: Object
  },
  template:
    `
      <DataGridDialog :visible.sync="visible"
                      v-bind="dialogAttrs">
        <template slot-scope="scope">
          <DataImportModule v-bind="attrs"
                            v-on="listeners">
            <span v-if="listeners && listeners.hideImport"
                  slot="external">
              <el-button size="mini" @click="hideImport">关闭窗口</el-button>
            </span>
          </DataImportModule>
        </template>
      </DataGridDialog>
    `,
  methods: {
    hideImport () {
      if (this.listeners && this.listeners.hideImport) {
        this.listeners.hideImport()
      }
    }
  }
})

let DialogUnpack = Vue.component('dialog-unpack', {
  components: {
    DataGridDialog,
    DataUnpackModule
  },
  props: {
    dialogAttrs: Object,
    attrs: Object,
    listeners: Object
  },
  template:
    `
      <DataGridDialog :visible.sync="visible"
                      v-bind="dialogAttrs">
        <template slot-scope="scope">
          <DataUnpackModule v-bind="attrs"
                            v-on="listeners">
            <span v-if="listeners && listeners.hideUnpack"
                  slot="external">
              <el-button size="mini" @click="hideUnpack">关闭窗口</el-button>
            </span>
          </DataUnpackModule>
        </template>
      </DataGridDialog>
    `,
  methods: {
    hideUnpack () {
      if (this.listeners && this.listeners.hideUnpack) {
        this.listeners.hideUnpack()
      }
    }
  }
})

let DialogAsync = Vue.component('dialog-async', {
  components: {
    DataGridDialog,
    AsyncTaskModule
  },
  props: {
    dialogAttrs: Object,
    attrs: Object,
    listeners: Object
  },
  template:
    `
      <DataGridDialog :visible.sync="visible"
                      v-bind="dialogAttrs">
        <template slot-scope="scope">
          <AsyncTaskModule v-bind="attrs"
                           v-on="listeners">
          </AsyncTaskModule>
        </template>
      </DataGridDialog>
    `
})

const popover = {
  $dialog ({parent, dialogAttrs, wrapAttrs, listeners, attrs}) {
    let instance = new PopoverDialog({
      parent: parent,
      propsData: {
        dialogAttrs,
        wrapAttrs,
        listeners,
        attrs
      },
      data () {
        return {
          visible: true
        }
      },
      methods: {
        onDeactivated () {
          this.visible = false
        },
        bindEvent () {
          if (parent) {
            parent.$on('hook:deactivated', this.onDeactivated)
          }
        },
        unbindEvent () {
          if (parent) {
            parent.$off('hook:deactivated', this.onDeactivated)
          }
        }
      },
      mounted () {
        this.bindEvent()
      },
      beforeDestroy () {
        this.unbindEvent()
      }
    })
    instance.$mount()
    document.body.appendChild(instance.$el)
    return instance
  },
  $drawer ({parent, drawerAttrs, listeners, attrs}) {
    let instance = new PopoverDrawer({
      parent: parent,
      propsData: {
        drawerAttrs,
        listeners,
        attrs
      },
      data () {
        return {
          visible: true
        }
      },
      methods: {
        onDeactivated () {
          this.visible = false
        },
        bindEvent () {
          if (parent) {
            parent.$on('hook:deactivated', this.onDeactivated)
          }
        },
        unbindEvent () {
          if (parent) {
            parent.$off('hook:deactivated', this.onDeactivated)
          }
        }
      },
      mounted () {
        this.bindEvent()
      },
      beforeDestroy () {
        this.unbindEvent()
      }
    })
    instance.$mount()
    document.body.appendChild(instance.$el)
    return instance
  },
  $cascade ({parent, cascadeAttrs, listeners, attrs}) {
    let instance = new PopoverCascade({
      parent: parent,
      propsData: {
        cascadeAttrs,
        listeners,
        attrs
      },
      data () {
        return {
          visible: true
        }
      }
    })
    instance.$mount()
    document.body.appendChild(instance.$el)
    return instance
  },
  $import ({parent, dialogAttrs, listeners, attrs}) {
    let instance = new DialogImport({
      parent: parent,
      propsData: {
        dialogAttrs,
        listeners,
        attrs
      },
      data () {
        return {
          visible: true
        }
      }
    })
    instance.$mount()
    document.body.appendChild(instance.$el)
    return instance
  },
  $unpack ({parent, dialogAttrs, listeners, attrs}) {
    let instance = new DialogUnpack({
      parent: parent,
      propsData: {
        dialogAttrs,
        listeners,
        attrs
      },
      data () {
        return {
          visible: true
        }
      }
    })
    instance.$mount()
    document.body.appendChild(instance.$el)
    return instance
  },
  $async ({parent, dialogAttrs, listeners, attrs}) {
    let instance = new DialogAsync({
      parent: parent,
      propsData: {
        dialogAttrs,
        listeners,
        attrs
      },
      data () {
        return {
          visible: true
        }
      }
    })
    instance.$mount()
    document.body.appendChild(instance.$el)
    return instance
  }
}

export default popover
